export function initStickyHeader() {
  const headerElem = document.querySelector('.header');
  if (!headerElem) return;

  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    const headerHeight = headerElem.clientHeight;

    const breadCrumbsElem = document.querySelector('ul.breadcrumbs');
    const breadCrumbsHeight = breadCrumbsElem
      ? breadCrumbsElem.offsetHeight
      : 0;

    if (
      currentScroll > lastScroll &&
      currentScroll > headerHeight &&
      window.innerWidth >= 1024
    ) {
      headerElem.style.transform = `translateY(calc(-100% - ${breadCrumbsHeight}px))`;
    } else {
      headerElem.style.transform = 'translateY(0)';
    }

    lastScroll = currentScroll;
  });
}
